export default defineNuxtRouteMiddleware(async (to, from) => {
  const directSignStore = useDirectSignStore()
  const languageStore = useLanguageStore()
  const userStore = useUserStore()

  // If current route has no query parameter, check the previous route
  const urlLang = languageStore.validateLanguageCode(to.query.lang ?? from.query.lang)
  // Removed Italian override as Italian is available on all pages

  // Only use language setting from user store in case the user is logged in
  const userLang = languageStore.validateLanguageCode(userStore.email ? languageStore.language : undefined)

  const browserLang = languageStore.validateLanguageCode(navigator.language?.split('-')[0])

  /* if a user isn't NAS, they will have a preference for language in
     their settings that should always take precedence. NAS get
     a default language from the inviter but the inviter can override this
     by adding the lang=<CODE> query, which should always take precedence.
     NOTE (07.08.25): NAS prefer url then browser language
     NOTE (18.07.25): NAS prefer browser language
     */
  const priorityLang = directSignStore.isDirectSign ? (urlLang ?? browserLang ?? userLang) : (userLang ?? urlLang)

  const languageCode = (priorityLang ?? browserLang ?? 'en') as Language

  await languageStore.setLanguage(languageCode)
})
